var exports = {
  "oM": "IndicatorsTab.module__itemsWrapper___T0hqNV",
  "tz": "IndicatorsTab.module__itemTextTertiary___T0hqNV",
  "Bp": "IndicatorsTab.module__avatarGroup___T0hqNV",
  "hD": "IndicatorsTab.module__stacksWrapper___T0hqNV",
  "KE": "IndicatorsTab.module__stackItem___T0hqNV",
  "U3": "IndicatorsTab.module__badgesWrapper___T0hqNV",
};

module.exports = exports;
